// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__2Oiz0","open":"Modal_open__15ht9","modal":"Modal_modal__3ixu-","closeButton":"Modal_closeButton__8C_Tm"};